import { useState, useEffect } from 'react';
import { Box, Button, Typography, Paper, Link, Fade } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      const timer = setTimeout(() => setShowBanner(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <Fade in={showBanner} timeout={400}>
      <Paper
        elevation={16}
        sx={{
          position: 'fixed',
          bottom: { xs: 0, sm: 24 },
          left: { xs: 0, sm: '50%' },
          right: { xs: 0, sm: 'auto' },
          transform: { xs: 'none', sm: 'translateX(-50%)' },
          maxWidth: { xs: '100%', sm: 760 },
          width: { xs: '100%', sm: 'calc(100% - 48px)' },
          p: { xs: 2.5, sm: 3 },
          zIndex: 9999,
          borderRadius: { xs: '12px 12px 0 0', sm: 3 },
          border: '1px solid',
          borderColor: 'divider',
          backdropFilter: 'blur(12px)',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'stretch', sm: 'center' },
            gap: { xs: 2, sm: 3 },
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle2" sx={{ mb: 0.5, fontWeight: 600 }}>
              Tu experiencia importa
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.5 }}>
              Usamos cookies de análisis para mejorar la plataforma. No usamos cookies publicitarias
              ni compartimos tus datos.{' '}
              <Link component={RouterLink} to="/legal?tab=cookies" sx={{ fontWeight: 500 }}>
                Política de cookies
              </Link>
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              flexShrink: 0,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={acceptCookies}
              sx={{ fontWeight: 600, py: 1, px: 3, whiteSpace: 'nowrap' }}
            >
              Aceptar
            </Button>
            <Button
              onClick={rejectCookies}
              size="small"
              sx={{
                color: 'text.secondary',
                textTransform: 'none',
                fontWeight: 400,
                fontSize: '0.8rem',
                whiteSpace: 'nowrap',
                minWidth: 'auto',
                px: 1,
                '&:hover': {
                  backgroundColor: 'transparent',
                  textDecoration: 'underline',
                },
              }}
            >
              No, gracias
            </Button>
          </Box>
        </Box>
      </Paper>
    </Fade>
  );
}
